import {memo} from 'react';
import Features from '../components/Features';
import HomeGallery from '../components/HomeGallery';
import HomeProducts from '../components/HomeProducts';
import Contact from './contact';

const Home = () => {
  return (
    <>
      <HomeGallery />
      <HomeProducts />
      <Features />
      <Contact />
    </>
  );
};

export default memo(Home);
